import { useTranslation } from 'react-i18next';
import { Badge } from '@/Domain/components/Shared/Badge/Badge';

interface IntegrationStatusBadgeProps {
  connected: boolean;
  /** OAuth landed but the merchant still has a step to complete before anything is live. */
  pending?: boolean;
}

/**
 * Standardized connection-status badge shown in every integration sheet header
 * next to the title: green when connected, neutral grey when not.
 */
export const IntegrationStatusBadge = ({ connected, pending }: IntegrationStatusBadgeProps) => {
  const { t } = useTranslation('integrations');
  const awaitingAction = Boolean(pending) && !connected;

  return (
    <Badge
      variant={connected ? 'success' : awaitingAction ? 'warning' : 'secondary'}
      size="sm"
      className="px-2"
      data-testid="integration-status-badge"
      data-connected={connected || undefined}
      data-pending={awaitingAction || undefined}
    >
      {connected
        ? t('status.connected')
        : awaitingAction
          ? t('status.finish_setup')
          : t('status.not_connected')}
    </Badge>
  );
};

export default IntegrationStatusBadge;
